<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="M10.125.503s.555 1.987.555 3.6c0 1.545-1.012 2.797-2.557 2.797C6.57 6.9 5.4 5.647 5.4 4.102l.022-.27A10.326 10.326 0 0 0 3 10.5c0 3.315 2.685 6 6 6s6-2.685 6-6c0-4.043-1.943-7.65-4.875-9.997ZM8.783 14.25c-1.335 0-2.415-1.05-2.415-2.355 0-1.215.787-2.07 2.107-2.34 1.328-.27 2.7-.907 3.465-1.935.293.968.443 1.987.443 3.03a3.6 3.6 0 0 1-3.6 3.6Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
